const percent = new Intl.NumberFormat('default', {
  style: 'percent',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

const percentFormatter = (val) => {
  const value = parseFloat(val || 0);
  const roundedValue = value.toFixed(2);
  const output = percent.format(parseFloat(roundedValue) / 100);
  return output;
};

export default percentFormatter;
